import { create } from 'zustand';
import { sendFullscreen } from '../channels/fullscreenChannel';

const SOCKET_SCREENS = [
  'Home',
  'Filtros'
];

export const isSocketScreen = (screen) => SOCKET_SCREENS.includes(screen);

const getMonitorMode = () => {
    
    const saved = localStorage.getItem('monitorMode');

    return saved
        ? Number(saved)
        : 0;
};

export const useScreenStore = create(
    (set, get) => ({
        
        screen: 'Login',

        monitorMode: getMonitorMode(),

        fullscreenOn: false,

        screenBlocked: false,

        setScreen: (screen) => {

            if (get().screen === screen) {
                return;
            }

            set({ screen });
        },

        setMonitorMode: (monitorMode) => {

            if (
                get().monitorMode === monitorMode
            ) {
                return;
            }

            localStorage.setItem(
                'monitorMode',
                monitorMode
            );

            set({ monitorMode });
        },

        setFullscreenOn: (fullscreenOn, broadcast = true) => {

            if (
                get().fullscreenOn === fullscreenOn
            ) {
                return;
            }

            set({ fullscreenOn });

            if (broadcast) {

                sendFullscreen(fullscreenOn);

            }
        },

        setScreenBlocked: (screenBlocked) => {

            if (get().screenBlocked === screenBlocked) {
                return;
            }

            set({ screenBlocked });
        },

    })
);